import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { ShieldAlert } from "lucide-react";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";

export default function ReportDialog({ target, onClose }) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => { setReason(""); }, [target]);

  const submit = async () => {
    if (!reason.trim()) { toast.error("Please tell us what happened."); return; }
    setLoading(true);
    try {
      await api.post("/reports", { ...target, reason });
      toast.success("Report submitted. Our team reviews every report. Thank you for keeping HAPLAP safe.");
      onClose();
    } catch (e) { toast.error(apiErr(e)); }
    setLoading(false);
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="report-dialog" className="sm:max-w-md rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl flex items-center gap-2 text-destructive">
            <ShieldAlert className="w-5 h-5" /> Report
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          We have a zero-tolerance policy for harassment. Tell us what happened and our team will act quickly.
        </p>
        <Textarea data-testid="report-reason-input" value={reason} onChange={(e) => setReason(e.target.value)}
          placeholder="Describe the issue…" rows={4} className="rounded-xl" />
        <Button data-testid="report-submit-btn" onClick={submit} disabled={loading}
          className="w-full bg-destructive hover:bg-destructive/90 text-white rounded-full">
          {loading ? "Submitting…" : "Submit report"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
